import { Subject_SubjectEnum } from '@protos/common/common.db_pb';
import { TeacherLoginResponseType } from '@protos/user_management/ums.login.apis_pb';

/**
 * Subject codes a teacher is allowed to create a project assessment for.
 *
 * Hard coded to RAI (Robotics & AI) for now. This is the only place the
 * allow-list lives: when the backend exposes it, swap the body of this
 * function for the API call and every project subject dropdown follows.
 */
export const getProjectAllowedSubjectCodes = (): Subject_SubjectEnum[] => [
  Subject_SubjectEnum.RAI,
];

export const isProjectAllowedSubjectCode = (
  subjectEnum?: Subject_SubjectEnum
) =>
  subjectEnum !== undefined &&
  getProjectAllowedSubjectCodes().includes(subjectEnum);

/**
 * The class-section rows of the teacher's roster that carry at least one
 * subject projects can be created for. The roster has one row per class and
 * section, each with its own subjects.
 */
export const getProjectClassSections = (
  userInfo?: TeacherLoginResponseType
) =>
  (userInfo?.teachClassSubjects ?? []).filter((classSection) =>
    classSection.subjects.some((subject) =>
      isProjectAllowedSubjectCode(subject.subjectEnum)
    )
  );

//~ Nothing to create a project for otherwise, so entry points stay hidden
export const canCreateProject = (userInfo?: TeacherLoginResponseType) =>
  getProjectClassSections(userInfo).length > 0;

/**
 * The section's subjects from the login response, narrowed to the codes
 * projects can be created for.
 */
export const getProjectSubjectsForClass = (props: {
  classId?: number;
  sectionId?: bigint;
  userInfo?: TeacherLoginResponseType;
}) => {
  const { classId, sectionId, userInfo } = props;
  if (!classId || sectionId === undefined) return [];

  const subjects =
    userInfo?.teachClassSubjects?.find(
      (classData) =>
        classData.classId === classId &&
        String(classData.sectionId) === String(sectionId)
    )?.subjects ?? [];

  return subjects
    .filter((subject) => isProjectAllowedSubjectCode(subject.subjectEnum))
    .map((subject) => ({
      name: subject.subjectName,
      id: subject.subjectId,
    }));
};
